import { createSlice } from '@reduxjs/toolkit';

import { ReducerStateType } from './types';

const initialState = {
  companyId: ''
} as ReducerStateType;

export const createPreIPODealStates = createSlice({
  name: 'createPreIPODealStates',
  initialState,
  reducers: {
    resetCreatePreIPODealStateValues: () => ({
      companyId: ''
    }),
    updateCreatePreIPODealStateValues: (state, { payload }) => ({
      ...state,
      ...payload
    })
  }
});

export const {
  resetCreatePreIPODealStateValues,
  updateCreatePreIPODealStateValues
} = createPreIPODealStates.actions;

export default createPreIPODealStates.reducer;
